import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/types';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { WeatherReportGrabber } from './WeatherReportSidebar';
import { WEATHER_REPORT_SCHEMA_URL, WEATHER_REPORT_COMPONENT_TYPE } from './WeatherReport.constants';

// Lazy load view components
const WeatherReportAdd = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorWeatherReportAdd" */ './WeatherReportSidebar'),
  'WeatherReportAdd',
);

const WeatherReportEdit = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorWeatherReportEdit" */ './admin/WeatherReportEdit'),
  'WeatherReportEdit',
);

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const WeatherReportConfig: AdminJsonComponentConfig = {
  schemaUrl: WEATHER_REPORT_SCHEMA_URL,
  componentType: WEATHER_REPORT_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: WeatherReportAdd,
    dragComponentView: WeatherReportGrabber,
    editComponentView: WeatherReportEdit,
    createComponentView: WeatherReportEdit,
  },
};
